var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTradeGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1173_3421",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.699951,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1173_3421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.77311 20.75C5.26799 20.75 4.84043 20.575 4.49043 20.225C4.14043 19.875 3.96543 19.4474 3.96543 18.9423V10.9538C3.56286 10.623 3.26061 10.1939 3.05868 9.66633C2.85676 9.13876 2.8526 8.56921 3.04618 7.95768L4.05773 4.65383C4.19106 4.23333 4.41735 3.89423 4.73658 3.63653C5.05581 3.37884 5.43722 3.25 5.88081 3.25H19.5308C19.9744 3.25 20.3532 3.37308 20.6673 3.61923C20.9814 3.86538 21.2103 4.20383 21.3539 4.6346L22.3846 7.95768C22.5782 8.56921 22.574 9.13683 22.3721 9.66055C22.1702 10.1843 21.868 10.6218 21.4654 10.9731V18.9423C21.4654 19.4474 21.2904 19.875 20.9404 20.225C20.5904 20.575 20.1628 20.75 19.6577 20.75H5.77311ZM14.9154 10.25C15.4616 10.25 15.8722 10.083 16.1472 9.74903C16.4222 9.41506 16.5347 9.05641 16.4847 8.67308L15.877 4.74995H13.4654V8.69998C13.4654 9.12049 13.6077 9.48396 13.8923 9.79038C14.1769 10.0968 14.518 10.25 14.9154 10.25ZM10.4154 10.25C10.8757 10.25 11.2491 10.0968 11.5356 9.79038C11.8222 9.48396 11.9654 9.12049 11.9654 8.69998V4.74995H9.55386L8.94616 8.71153C8.89232 9.06666 9.00386 9.41185 9.28078 9.7471C9.55771 10.0824 9.93592 10.25 10.4154 10.25ZM5.96541 10.25C6.33592 10.25 6.65452 10.1208 6.92121 9.8625C7.18787 9.60415 7.35261 9.27947 7.41543 8.88845L8.00391 4.74995H5.88081C5.77182 4.74995 5.68528 4.77399 5.62118 4.82208C5.55706 4.87016 5.50898 4.94228 5.47693 5.03845L4.51541 8.29228C4.38334 8.72178 4.44551 9.15544 4.70193 9.59325C4.95835 10.0311 5.37951 10.25 5.96541 10.25ZM19.4654 10.25C20.0064 10.25 20.4205 10.0375 20.7077 9.6125C20.9949 9.18748 21.0641 8.74741 20.9154 8.29228L19.9039 5.0192C19.8718 4.92305 19.8238 4.85413 19.7597 4.81245C19.6956 4.77078 19.609 4.74995 19.5 4.74995H17.4269L18.0154 8.88845C18.0782 9.27947 18.243 9.60415 18.5096 9.8625C18.7763 10.1208 19.0949 10.25 19.4654 10.25Z",
    fill: "#1EB65B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradeGreen);
export default __webpack_public_path__ + "static/media/trade_green.5f3064b117edef74c2ed25c0ee6129c7.svg";
export { ForwardRef as ReactComponent };